export default "__VITE_ASSET__AUdR7yrk__"